// extracted by mini-css-extract-plugin
export var buttonsWrapper = "ModalFooter-module--buttonsWrapper--1ef7e";
export var fadeInAnimation = "ModalFooter-module--fadeInAnimation--2f6c7";
export var modalFooter = "ModalFooter-module--modalFooter--5865a";
export var withSummary = "ModalFooter-module--withSummary--b1015";